import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import { listClubs } from 'redux/clubs/actions';
import { getCustomer } from 'redux/customer/actions';

import Club from './components/Club';

class List extends Component {
  componentDidMount() {
    const { props } = this;
    props.listClubs(true);
    props.getCustomer();
  }

  render() {
    const { settings, clubs } = this.props;
    if (!settings.data || !clubs.data) {
      return (
        <Layout title="Our Clubs" loading>
          <Title>Our Clubs</Title>
        </Layout>
      );
    }
    const clubIdArray = Object.keys(clubs.data);
    return (
      <Layout title="Our Clubs" showSideCart={false}>
        <Title>Our Clubs</Title>

        <div>
          <div className="c7-club-list">
            {clubIdArray.map((clubId) => (
              <Club key={clubId} club={clubs.data[clubId]} />
            ))}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  clubs: state.club,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listClubs,
  getCustomer
})(List);
